import { Grid } from "@mui/material";
import React from "react";
import loader_image from "../../Assets/Images/gear-spinner.svg"

const LoaderAnimation = () => {
  return (
    <Grid
      container
      lg={12}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <img src={loader_image} className="circle-rotate rounded-circle" alt="loader_img" style={{height:"100px" , width:"100px"}} />
    </Grid>
  );
};

export default LoaderAnimation;
